<div class="logo">
    <a class="mobile" [ngClass]="{ 'mobile--checkout': checkoutNavLogo} " uiSref="landing.landing" (click)="closeNav()">
        <xm-media-image [staticImagePath]="'cbm-logo-white.svg'" staticImageAlt="" [imageSource]="'buy_static_base_url'"></xm-media-image>
    </a>
    <a class="desktop" uiSref="landing.landing">
        <xm-media-image [staticImagePath]="'cbm-logo-white.svg'" staticImageAlt="" [imageSource]="'buy_static_base_url'"></xm-media-image>
    </a>
</div>
